/**
 * "Aus Vorlage": choose one of a format's example sets, copy it into the
 * library and open it in the editor (dashboard and start dialog).
 */
import { api } from '@shared/api';
import { esc } from '@shared/dom';
import { t } from '@shared/i18n/de';
import { navigate } from '@shared/router';
import { openDialog } from '@shared/ui/dialog';
import { toast, toastError } from '@shared/ui/toast';

/** Choose a module's example set and copy it into the library, then open it. */
export async function openExamples(gameId: string): Promise<void> {
  let examples: { index: number; title: string; description: string }[];
  try {
    examples = (
      await api<{ examples: typeof examples }>(`/api/games/${encodeURIComponent(gameId)}/examples`)
    ).examples;
  } catch (err) {
    toastError(err);
    return;
  }
  const body = `<p class="muted">${t('library.examplesLead')}</p>
    <div class="example-list">
      ${examples
        .map(
          (e, i) => `<label class="example" style="animation-delay:${String(i * 70)}ms">
            <input type="radio" name="example" value="${String(e.index)}" ${i === 0 ? 'checked' : ''} />
            <span><strong>${esc(e.title)}</strong><br /><span class="muted">${esc(e.description)}</span></span>
          </label>`,
        )
        .join('')}
    </div>`;
  const dialog = openDialog({
    title: t('library.examplesTitle'),
    body,
    actions: [
      { label: t('teacher.cancel'), value: 'cancel', kind: 'ghost' },
      { label: t('library.useExample'), value: 'use' },
    ],
    async onSubmit(form) {
      const index = new FormData(form).get('example');
      if (typeof index !== 'string') return false;
      try {
        const copy = await api<{ id: string }>(
          `/api/games/${encodeURIComponent(gameId)}/examples/${encodeURIComponent(index)}`,
          { method: 'POST' },
        );
        toast(t('library.exampleCopied'), 'success');
        navigate(`/lehrer/sets/${copy.id}`);
        return true;
      } catch (err) {
        toastError(err);
        return false;
      }
    },
  });
  await dialog.result;
}
